import { schools } from '../services/bff.api';

export const SCHOOLS_RESOURCE = {
  key: 'SCHOOLS_RESOURCE',
  table: {
    defaultSort: 'name',
    dataLocation: '_embedded.resourceList',
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i,
        key: i.id,
        value: i.id,
        label: i.name,
        branches: i?.branches?.map((b) => ({ ...b, key: b.id, value: b.id, label: b.name }))
      }))
  },
  api: {
    get: schools.getAll
  }
};
